import { createContext } from 'react';
import { Context } from './types';

export const PlanMapEventsContext =
    createContext<Context | undefined>(undefined);
